import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useLocalStorage } from '@grandvisionhq/utils';
import { handleConversionEvent } from './AlgoliaAnalyticsHelpers.js';

const ALGOLIA_ANALYTICS_STORAGE_KEY = 'algoliaAnalyticsData';
const useAlgoliaAnalytics = ()=>{
    const [data1, setData] = useLocalStorage(ALGOLIA_ANALYTICS_STORAGE_KEY, {
        queryId: undefined,
        searchIndex: ''
    });
    const saveData = React__default.useCallback((newData)=>{
        setData(newData);
    }, []);
    const clearQueryId = React__default.useCallback(()=>{
        setData((data = {})=>swcHelpers.objectSpread({}, data, {
                queryId: undefined
            })
        );
    }, [
        data1
    ]);
    const handleConversionEvent$1 = React__default.useCallback((objectId, queryId)=>{
        if (data1) {
            handleConversionEvent({
                objectIds: objectId,
                searchIndex: data1.searchIndex,
                queryId
            });
        }
    }, [
        data1
    ]);
    return {
        algoliaAnalyticsData: data1,
        saveData,
        clearQueryId,
        handleConversionEvent: handleConversionEvent$1
    };
};

export { ALGOLIA_ANALYTICS_STORAGE_KEY, useAlgoliaAnalytics as default, useAlgoliaAnalytics };
//# sourceMappingURL=useAlgoliaAnalytics.js.map
